import styles from "@/styles/Price.module.scss";
import formatPrice from "@/lib/formatPrice";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FormatPriceTVOD(_ref) {
  var price = _ref.price,
      ext = _ref.ext;
  return /*#__PURE__*/_jsxs("span", {
    className: "".concat(styles.price, " ").concat(styles.tvod),
    children: ["\u4FA1\u683C\uFF1A", /*#__PURE__*/_jsxs("span", {
      className: styles.priceNum,
      children: [formatPrice(price), "\u5186"]
    }), "\uFF08\u7A0E\u8FBC\uFF09", ext]
  });
}